<template>
  <div>
    <ContentHeader title="Subscription" />
    <table-skeleton v-if="loading"></table-skeleton>
    <section v-else class="content">
      <div class="container-fluid">
        <div class="card filter active">
          <div class="row p-3">
            <div class="col-md-3">
              <label for="statusFilter">Status</label>
              <select
                id="statusFilter"
                class="form-select"
                v-model="filter.subStatus"
              >
                <option
                  v-for="item in statusList"
                  :key="item.index"
                  :value="item.status"
                >
                  {{ item.status }}
                </option>
              </select>
            </div>
            <div class="col">
              <label for="robotName">Robot Name</label>
              <select
                id="robotName"
                class="form-select"
                v-model="filter.robotName"
              >
                <option value="ALL">ALL</option>
                <option
                  v-for="item in robots"
                  :key="item.index"
                  :value="item.name"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <div class="card-tools">
                  <div class="d-flex filter-container">
                    <select
                      class="form-select mr-3 w-25 select-perpage"
                      v-model="table.perPage"
                    >
                      <option value="5">5</option>
                      <option value="10" selected>10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                    <input
                      type="text"
                      name="search"
                      class="form-control w-75 search-bar"
                      placeholder="Search"
                      v-model="table.filter"
                    />
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <b-table
                  hover
                  responsive
                  :items="subscriptionData"
                  :fields="table.fields"
                  :current-page="table.currentPage"
                  :per-page="table.perPage"
                  :filter="table.filter"
                  :filter-included-fields="['product_name', 'investor_name']"
                  @filtered="onFiltered"
                  show-empty
                >
                  <template #empty="scope">
                    <p class="text-center">
                      {{ scope.emptyText }}
                    </p>
                  </template>
                  <template #emptyFiltered="scope">
                    <p class="text-center">
                      {{ scope.emptyFilteredText }}
                    </p>
                  </template>
                  <template #cell(No)="data">
                    {{
                      (table.currentPage - 1) * table.perPage + data.index + 1
                    }}
                  </template>
                  <template #cell(installation_status)="data">
                    <button
                      class="btn btn-outline-warning rounded-pill"
                      v-if="data.item.installation_status === 'PENDING'"
                      @click="
                        showModal(
                          'change-date-modal',
                          data.item.id,
                          data.item.created_at
                        )
                      "
                    >
                      PENDING
                    </button>
                    <button
                      class="btn btn-success rounded-pill"
                      v-else-if="data.item.installation_status === 'INSTALLED'"
                    >
                      INSTALLED
                    </button>
                    <button
                      class="btn btn-danger rounded-pill"
                      v-else-if="data.item.installation_status === 'EXPIRED'"
                    >
                      EXPIRED
                    </button>
                  </template>
                  <template #cell(created_at)="data">
                    {{ formatDate(data.item.created_at) }}
                  </template>
                  <template #cell(id)="data">
                    <a
                      href="#"
                      @click="showDetail('view-detail-modal', data.item)"
                    >
                      <i class="fas fa-eye text-info"></i>
                    </a>
                  </template>
                </b-table>
              </div>
              <b-pagination
                v-model="table.currentPage"
                :total-rows="subscriptionData.length"
                :per-page="table.perPage"
                class="my-0 p-3"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal
      id="change-date-modal"
      ref="change-date-modal"
      centered
      hide-footer
      hide-header
    >
      <form @submit.prevent="changeStatus(form.subscription_id)">
        <div>
          <label for="active-date" class="form-label">Active Date</label>
          <b-calendar
            id="active-date"
            block
            :min="form.min_date"
            :max="form.max_date"
            v-model="form.date"
            locale="en-US"
            class="rounded calendar-input"
            :class="{
              'border border-danger': $v.form.date.$error,
            }"
          ></b-calendar>
          <div class="text-danger" v-if="$v.form.date.$error">
            <small>Active Date Required</small>
          </div>
        </div>
        <!-- <input type="date" class="form-control"> -->
        <div class="py-3 d-flex flex-column">
          <button
            class="btn btn-success w-100 mb-3"
            type="submit"
            :disabled="submitStatus === 'PENDING'"
          >
            Submit
          </button>

          <button
            class="btn btn-outline-danger w-100"
            type="button"
            @click="hideModal('change-date-modal')"
          >
            Close
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal
      id="view-detail-modal"
      ref="view-detail-modal"
      title="Subscription Detail"
      centered
      hide-footer
    >
      <table>
        <tr>
          <th class="pe-4">Investor</th>
          <td><b class="pe-1">:</b> {{ sub_detail.investor.name }}</td>
        </tr>
        <tr>
          <th class="pe-4">Deposit</th>
          <td><b class="pe-1">:</b>{{ sub_detail.transaction.deposit_amount }}</td>
        </tr>
        <tr>
          <th class="pe-4">Account Number</th>
          <td><b class="pe-1">:</b>{{account_number}}</td>
        </tr>
        <tr>
          <th class="pe-4">Trader Password</th>
          <td><b class="pe-1">:</b>{{trader_password}}</td>
        </tr>
        <tr>
          <th class="pe-4">Broker Name</th>
          <td><b class="pe-1">:</b>{{ brokercheck(sub_detail.transaction.broker_choice) }}</td>
        </tr>
        <tr>
          <th class="pe-4">Broker Server</th>
          <td><b class="pe-1">:</b>{{broker_server }}</td>
        </tr>
        <tr>
          <th class="pe-4">Installation note</th>
          <td><b class="pe-1">: {{sub_detail.installation_note}}</b></td>
        </tr>
        <tr>
          <th class="pe-4">Subscription Date</th>
          <td>
            <b class="pe-1">:</b> {{ formatDate(sub_detail.created_at) }}
          </td>
        </tr>
        <tr>
          <th class="pe-4">Status</th>
          <td>
            <b class="pe-2">:</b>
            <span
              :class="{
                'text-warning': sub_detail.installation_status === 'PENDING',
                'text-danger': sub_detail.installation_status === 'EXPIRED',
                'text-success':
                  sub_detail.installation_status === 'INSTALLED',
              }"
              >{{ sub_detail.installation_status }}</span
            >
          </td>
        </tr>
        <tr>
          <th class="pe-4">Robot</th>
          <td><b class="pe-1">:</b> {{ sub_detail.product_name }}</td>
        </tr>
      </table>
    </b-modal>
  </div>
</template>

<script>
import TableSkeleton from "@/components/loading-screen/TableSkeleton.vue";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import apiVendor from "../services/VendorApiServices";
import apiClient from "../services/ApiServices";
import apiBroker from "../services/BrokerApiServices";

export default {
  components: {
    ContentHeader,
    TableSkeleton,
  },
  data() {
    const now = new Date();

    return {
      submitStatus: null,
      loading: true,
      robots: [],
      brokers: [],
      subscriptions: [],
      account_number: '',
      trader_password: '',
      broker_server: '',
      sub_detail: {
        investor:{
          name:''
        },
        transaction:{
          deposit_amount:'',
          currency:'',
          broker_choice:'',
          broker_account_id:'',
        }
      },
      form: {
        subscriptions_id: null,
        min_date: null,
        max_date: now,
        date: null,
      },
      filter: {
        subStatus: "ALL",
        robotName: "ALL",
      },
      statusList: [
        { status: "ALL" },
        { status: "INSTALLED" },
        { status: "PENDING" },
        { status: "EXPIRED" },
      ],
      table: {
        currentPage: 1,
        totalRows: 1,
        perPage: 10,
        filter: "",
        fields: [
          "No",
          {
            key: "investor_name",
            sortable: true,
          },
          {
            label: "Robot Name",
            key: "product_name",
            sortable: false,
          },
          {
            label: "Subscribed At",
            key: "created_at",
            sortable: true,
          },
          {
            key: "installation_status",
            sortable: true,
          },
          {
            label: "Action",
            key: "id",
          },
        ],
      },
    };
  },
  validations: {
    form: {
      date: {
        required,
      },
    },
  },
  async mounted() {
    try {
      const subResponse = await apiVendor.get(
        `${this.$user_id}/subscriptions/`
      );
      let databroker = await apiBroker.get(`/`)

      this.brokers = databroker.data.data
      if(subResponse.data?.data){
        this.subscriptions = subResponse.data?.data;
      }
      
      const robotResponse = await apiClient.get(`?vendor_id=${this.$user_id}&without_broker=true`);
      if(robotResponse.data?.data){
        this.robots = robotResponse.data?.data;
      }

      this.table.totalRows = this.subscriptions.length;
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.response.data.data.massage,
        "error"
      );
    } finally {
      this.loading = false;
      if(this.$route.query.data == 'INSTALLED'){
          this.filter.subStatus = this.$route.query.data
          this.table.totalRows = this.subscriptions.length;
      // }else if(this.$route.query.data  != 'INSTALLED'){
      //   this.listdatasub =this.items
      // }                      
      // if(){
      //   this.filter.subStatus = ""
      }
    }
  },
  computed: {
    subscriptionData() {
      if (this.filter.subStatus === "ALL" && this.filter.robotName === "ALL") {
        return this.subscriptions;
      } else if (
        this.filter.subStatus === "ALL" &&
        this.filter.robotName != "ALL"
      ) {
        return this.subscriptions.filter(
          (item) => item.product_name == this.filter.robotName
        );
      } else if (
        this.filter.subStatus != "ALL" &&
        this.filter.robotName == "ALL"
      ) {
        return this.subscriptions.filter(
          (item) => item.installation_status == this.filter.subStatus
        );
      }

      return this.subscriptions.filter(
        (item) =>
          item.installation_status == this.filter.subStatus &&
          item.product_name == this.filter.robotName
      );
    },
  },
  methods: {
    brokercheck(data){
      // let datap = this.brokers.filter(item => item.id.include(data))
      if(data){
        let dataBroker =  this.brokers.filter(x => x.id == data)
        return dataBroker[0].name
      }
    //  return dataBroker[0].name
    },
    changeStatus(id) {
      let data = new FormData();
      data.append("installation_status", "INSTALLED");
      data.append("active_date", this.form.date);

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";

        this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, change it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await apiVendor.put(
                `${this.$user_id}/subscriptions/${id}/`,
                data
              );
              this.subscriptions.find(
                (item) => item.id === id
              ).installation_status = "INSTALLED";
              this.$swal(
                "Changed!",
                "Subscription status has changed.",
                "success"
              );

              this.hideModal("change-date-modal");
              this.submitStatus = "OK";
            } catch (error) {
              this.$swal("Failed!", "Something went wrong.", "fail");
              this.submitStatus = "ERROR";
            }
          } else {
            this.submitStatus = "ERROR";
          }
        });
      }
    },
    formatDate(value) {
      return moment(value).format("DD MMMM YYYY hh:mm");
    },
    onFiltered(items) {
      this.table.totalRows = items.length;
      this.table.currentPage = 1;
    },
    showModal(modal, id, min_date) {
      this.form.subscription_id = id;
      this.form.min_date = min_date;
      this.form.date = null;
      this.$v.$reset();
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
      this.form.subscriptions_id = null;
      this.form.min_date = null;
      this.form.date = null;
      this.$v.$reset();
    },
    async showDetail(modal,data) {
      this.sub_detail = data
      
      let databroker = await apiVendor.get(`investor/${data.investor_id}/broker/${data.transaction.broker_account_id}`)
      // console.log(databroker);
      this.account_number = databroker?.data?.data?.account_number
      this.broker_server = databroker?.data?.data?.broker_server
      this.trader_password = databroker?.data?.data?.trader_password
      // const robotResponse = await apiClient.get(`brokerchoice/`+this.sub_detail.transaction.broker_account_id);
      // console.log(robotResponse);
      this.$refs[modal].show();
    },
  },
};
</script>

<style scoped>
@media (max-width: 767px) {
  .filter .col-md-3 .form-select {
    margin-bottom: 1rem !important;
  }
}
.filter {
  transition: max-height 0.75s ease-in-out;
  max-height: 0;
}
.filter.active {
  max-height: 500px;
}
.filter .form-select {
  transition: max-height 0.75s ease-in-out;
  max-height: 0;
}
.filter.active .form-select {
  max-height: 300px;
}
</style>